import axios from 'axios'
import Vue from 'vue'
import { convertToQueryString, filterNonEmptyValues, buildFilterSearchParams } from '@/utils'

const filterMap = {
  avgLikePosts: {
    name: 'Avg. likes/post',
    tooltip: 'Avg. likes/post',
    sortable: true,
    unlock: true,
    key: 'avg_likes',
    filter: {
      name: 'numbro',
    },
  },
  avgCommentsPost: {
    name: 'Avg. comm./post',
    tooltip: 'Avg. comments/post',
    sortable: true,
    unlock: true,
    key: 'avg_comments',
    filter: {
      name: 'numbro',
    },
  },
  audienceAge: {
    name: 'Aud. age',
    sortable: true,
    unlock: true,
    key: 'age.value',
    filter: {
      name: 'numbro',
    },
    suffix: '%',
  },
  audienceGender: {
    name: 'Aud. gender',
    unlock: true,
    key: 'gender.value',
    suffix: '%',
    updateName: {
      value: {
        F: 'Female',
        M: 'Male',
        U: 'Other',
      },
    },
  },
  audienceLocation: {
    name: 'Aud. location',
    unlock: true,
    key: 'country.value',
    suffix: '%',
    updateName: {
      field: 'label',
    },
  },
  avgReachPost: {
    name: 'Avg. reach/post',
    unlock: true,
    key: 'reach',
    filter: {
      name: 'numbro',
    },
  },
}

// state
export const state = {
  filters: {},
  filterData: false,
  countResults: -1,
  loading: false,
  filterPresets: [],
  currentPreset: false,
  meta: {
    campaign: false,
  },
  filtersTbl: [],
}

export const getters = {
  getFilters: (state) => state.filters,
  getFilterData: (state) => state.filterData,
  getCategories: (state) => state.categories,
  getProfileType: (state) => state.profileType,
  getCountResults: (state) => state.countResults,
  getFilterPresets: (state) => state.filterPresets,
  getCurrentPreset: (state) => state.currentPreset,
  getFiltersTbl: (state) => state.filtersTbl,
  getMeta: (state) => state.meta,
  getLoading: (state) => state.loading,
}

export const mutations = {
  SET_FILTER(state, payload) {
    if (payload.value === 'removeKey') {
      Vue.delete(state.filters, payload.key)
    } else {
      Vue.set(state.filters, payload.key, payload.value)
    }
  },
  SET_FILTERS(state, payload) {
    state.filters = payload || {}
  },
  REMOVE_FILTERS(state) {
    state.filters = {}
  },
  SET_FILTER_DATA(state, payload) {
    state.filterData = payload
  },
  SET_CATEGORIES(state, payload) {
    const categoriesData = []
    payload?.map((item) => {
      categoriesData.push({
        value: item.id,
        label: item.name,
      })
    })
    state.categories = categoriesData
  },
  SET_COUNT(state, payload) {
    state.countResults = payload
  },
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_FILTER_PRESETS(state, payload) {
    state.filterPresets = payload
  },
  SET_FILTER_PRESET(state, payload) {
    state.filterPresets.push(payload)
  },
  SET_CURRENT_PRESET(state, payload) {
    state.currentPreset = payload
  },
  SET_META(state, payload) {
    state.meta[payload.key] = payload.value
  },
  SET_FILTERS_TBL(state, payload) {
    state.filtersTbl = payload
  },
}

export const actions = {
  async getCountResults({ commit, state }, payload) {
    commit('SET_LOADING', true)
    let tabUrl = ''

    if (payload?.route.name === 'campaign-recommended-creators') {
      tabUrl = 'recommended-creators'
    }

    if (payload?.route.name === 'campaign-group-creators') {
      tabUrl = 'group-creators'
    }

    const filterParams = buildFilterSearchParams(state.filters, payload?.route?.query)

    let filterULR = `/api/campaign/${payload?.route?.params?.id}/group/${payload?.route?.params?.group_id}/${tabUrl}?${convertToQueryString(
      filterParams
    )}`

    if (payload?.route.name === 'campaign-favorite-creators') {
      filterULR = `/api/creators/favorites/${payload?.route?.params?.id}/${payload?.route?.params?.group_id}?${convertToQueryString(
        filterParams
      )}`
    }

    try {
      const { data } = await axios.get(`${filterULR}&count`)
      commit('SET_COUNT', data.count)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getFilterData({ commit, state }, payload) {
    if (state.filterData) {
      return false
    }

    const options = {}

    if (payload?.params) {
      options.params = payload.params
    }

    commit('SET_LOADING', true)
    const { data } = await axios.get(`/api/filters/data`, options)
    commit('SET_LOADING', false)
    commit('SET_FILTER_DATA', data)
  },
  // eslint-disable-next-line no-empty-pattern
  async searchCountry({}, country_name) {
    const { data } = await axios.get(`/api/filters/search-country?country=${country_name}`)
    return data
  },
  // eslint-disable-next-line no-empty-pattern
  async searchRegion({}, payload) {
    const { data } = await axios.get(`/api/filters/search-region?country_id=${payload.country_id}&region_name=${payload.region_name}`)
    return data
  },
  async getPresets({ commit }, section) {
    const params = { section }

    const { data } = await axios.get('/api/filters/presets', { params })
    commit('SET_FILTER_PRESETS', data)
  },
  async getLastPreset({ commit }) {
    const { data } = await axios.get('/api/filters/presets', { params: { last: true } })
    commit('SET_FILTERS', data?.filters)
    commit('SET_CURRENT_PRESET', data)
  },
  async saveFilterPresets({ commit, state }, payload) {
    const { data } = await axios.post('/api/filters/presets', {
      ...payload,
      filters: filterNonEmptyValues(state.filters),
    })

    const responseData = {
      id: data?.id,
      name: data?.name,
      filters: data?.filters,
    }

    commit('SET_FILTER_PRESET', responseData)
  },
  async updateFilterPresets({ commit, state }, payload) {
    const { data } = await axios.put(`/api/filters/presets/${payload.id}`, {
      ...payload,
      filters: filterNonEmptyValues(state.filters),
    })
    const replaceData = state.filterPresets.map((item) => {
      if (item.id === data.id) {
        ;(item.name = data.name), (item.filters = data.filters)
      }
      return item
    })
    commit('SET_FILTER_PRESETS', replaceData)
  },
  async removePreset({ commit, state }, id) {
    try {
      await axios.delete(`/api/filters/presets/${id}`)
      const presetsData = state.filterPresets.filter((item) => item.id !== id)
      commit('SET_FILTER_PRESETS', presetsData)
    } catch (err) {
      return err
    }
  },
  updateFiltersTbl({ commit, state }) {
    const filtersTbl = []
    Object.keys(state.filters).forEach((item) => {
      if (filterMap[item]) {
        if (filterMap[item]?.updateName) {
          filterMap[item].name = filterMap[item]?.updateName?.field
            ? state.filters[item][filterMap[item].updateName.field]
            : filterMap[item].updateName.value[state.filters[item]]
        }
        filtersTbl.push(filterMap[item])
      }
    })

    commit('SET_FILTERS_TBL', filtersTbl)
  },
}
